module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAAJCAYAAADgkQYQAAAABmJLR0QA6wArAAXiNRA/AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAB3RJTUUH4QsOEDcNdFNbXAAAABl0RVh0Q29tbWVudABDcmVhdGVkIHdpdGggR0lNUFeBDhcAAADISURBVBjTjZAtTgNhFEXP+35pwWEhbepBoBFlE+PYCAvoIljC6Hoq2AeZFNuQIErn++bNQ9Cie9xNrjj3yu4+4aLj8fp2hUgDzIAOs/Z9t30Z64h8PWSWN4u3EP0SEf4xY6i62Xx+PPn13WKVJvE5TRP5KpEmkXgREOew0eav4TIHRBpECNmTpgkfPVoVKJQfAZEmHB0QEXz0hOw55SMzB3R/CoZWZegVrYqZnUqdw6zFjKFXyr5w+D5Q9oWhVzADs/asdXLOT79qBmRkJJt1kwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/game/assets/bullet.png
// module id = 72
// module chunks = 0